import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import SignaturePad from "@/components/SignaturePad";
import { useApp } from "@/context/AppContext";
import { t, formatMoney } from "@/i18n";

/** OTP-based signature dialog for a bilateral intermediation contract. */
export default function IntermediationSignDialog({
  contract,
  open,
  onClose,
  onRequestOtp,
  onSubmit,
  otpRequested,
  otpCode,
  setOtpCode,
  setSignature,
  busy,
}) {
  const { lang } = useApp();
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#FFFAF0] border-[#D8CFBB] text-[#1A1610] max-w-lg">
        <DialogHeader>
          <DialogTitle className="text-2xl font-light" style={{ fontFamily: "Cormorant Garamond, serif" }}>
            {t("interm_sign_dialog_title", lang)}
          </DialogTitle>
        </DialogHeader>
        {contract && (
          <div className="space-y-4 py-2">
            <div className="rounded-md border border-[#D8CFBB] bg-[#F5F0E6] p-3 text-xs text-[#4A3F30] leading-relaxed">
              <p className="uppercase tracking-widest text-[#C5A880] text-[10px] mb-1">Intermediazione</p>
              <p>
                <b>{contract.property_title}</b> · {contract.property_city} · {formatMoney(contract.property_price, lang)}
              </p>
              <p className="mt-1">{t("agent", lang)}: {contract.agent_name}</p>
            </div>
            <SignaturePad onChange={setSignature} testId="interm-signature-pad" />
            {!otpRequested && (
              <Button
                onClick={onRequestOtp}
                disabled={busy}
                data-testid="interm-request-otp"
                className="bg-[#1A1610] text-[#F5F0E6] hover:bg-[#2E2A22] rounded-full"
              >
                {busy ? "…" : t("send_otp_email", lang)}
              </Button>
            )}
            {otpRequested && (
              <Input
                data-testid="interm-otp-input"
                className="bg-[#F5F0E6] border-[#D8CFBB] text-center font-mono tracking-[0.4em]"
                maxLength={6}
                placeholder="000000"
                value={otpCode}
                onChange={(e) => setOtpCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
              />
            )}
          </div>
        )}
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} className="text-[#4A3F30]">
            {t("cancel", lang)}
          </Button>
          <Button
            onClick={onSubmit}
            disabled={!otpRequested || otpCode.length !== 6 || busy}
            data-testid="interm-sign-submit"
            className="bg-[#C5A880] text-black hover:bg-[#d9bf94] rounded-full disabled:opacity-40"
          >
            {busy ? "…" : t("sign_with_otp", lang)}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
